import { numberMoney } from 'Data/format.js'
import { getAdjustedTreatmentFeeAfterInsurances } from 'Data/payment-plan.js'

export function getValue(payment_plan) {
  return numberMoney(getAdjustedTreatmentFeeAfterInsurances(payment_plan))
}
